import { BookLessons, GetBookLessons } from '@/entities/books/model/types.ts';
import { axiosInstance } from '@/shared/core';

/**
 * Получение списка уроков книги
 *
 * @returns Список уроков книг GetBookLessons
 */
export const getBookAllLessons = async (
  bookId: string,
): Promise<GetBookLessons> => {
  const response = await axiosInstance.get<GetBookLessons>(
    `/lesson/getAllByBook?bookId=${bookId}`,
  );

  return response.data;
};

/**
 * Получение урока
 *
 * @returns Урок Book
 */
export const getLessonById = async (lessonId: string): Promise<BookLessons> => {
  const response = await axiosInstance.get<BookLessons>(
    `/lesson/get?lessonId=${lessonId}`,
  );

  return response.data;
};

/**
 * Создание урока книги
 *
 * @returns Созданный урок GetBookLessons
 */
export const createLesson = async (data: BookLessons) => {
  return await axiosInstance.post('/lesson/create', data);
};

/**
 * Редактирование урока
 *
 * @returns Отредактированный урок BookLessons
 */
export const updateLesson = async (data: BookLessons): Promise<BookLessons> =>
  await axiosInstance.post(`/lesson/update`, data);

/**
 * Загрузка аудио урока
 *
 * @returns Сохраненный путь аудио string
 */
export const addBookLessonAudio = async (
  data: FormData,
): Promise<{ url: string }> => {
  return (await axiosInstance.post('/lesson/uploadAudio', data)).data;
};

/**
 * Удаление урока
 *
 * @returns Удаленный урок BookLessons
 */
export const deleteLesson = async (id: number) => {
  return await axiosInstance.post(`/lesson/delete`, { id });
};

/**
 * Создание массовой загрузки аудио
 *
 */
export const addBatchLesson = async (data: FormData) => {
  return await axiosInstance.post('/lesson/batch/create', data);
};

/**
 * Проверка статуса массовой загрузки аудио
 *
 * @returns Состояние статуса BatchProcessStatus
 */
export const getStatusAudioProcess = async (bookId: string | number) => {
  return await axiosInstance.get(`/lesson/batch/status`, {
    params: { bookId },
  });
};
